// @flow
// Libs
import React, { Component } from 'react'

// Components
import Select from 'react-select'

// Styles
import './inputRange.scss'
import commonStyles from './style'

// Types
type Props = {
  config: Object,
  value: number | string,
  selectedOption: Object,
  style: Object,
  stylingClasses: string,
  options: Array<Object>,
  onChange: Function,
  getSelectedOption: Function,
}

class InteractiveSelect extends Component {
  props: Props
  static defaultProps = {
    style: {},
    stylingClasses: '',
  }

  constructor (props: Props) {
    super(props)

    this.blurHandler = this.blurHandler.bind(this)
    this.increment = this.increment.bind(this)
    this.decrement = this.decrement.bind(this)
  }

  blurHandler (e: Object) {
    if (!e.target.value) {
      return
    }

    let value = Math.round(e.target.value * this.props.config.ROUND_COEF) / this.props.config.ROUND_COEF

    if (value > this.props.config.MAX_VALUE) {
      value = this.props.config.MAX_VALUE
    }

    if (value < this.props.config.MIN_VALUE) {
      value = this.props.config.MIN_VALUE
    }

    const selectedOption = this.props.getSelectedOption(value)

    if (selectedOption) {
      this.props.onChange(value)
    }
  }

  increment () {
    const incrementedVal = this.props.value + this.props.config.STEP

    if (incrementedVal <= this.props.config.MAX_VALUE) {
      this.props.onChange(incrementedVal)
    }
  }

  decrement () {
    const decrementedVal = this.props.value - this.props.config.STEP

    if (decrementedVal >= this.props.config.MIN_VALUE) {
      this.props.onChange(decrementedVal)
    }
  }

  render (): React.Element<any> {
    return (
      <div style={{...commonStyles.selectWrapper, ...this.props.style.selectWrapper}}>
        <Select
          id={`grid-tool-${this.props.config.VALUE_LABEL}`}
          name={`grid-tool-${this.props.config.VALUE_LABEL}`}
          value={this.props.selectedOption}
          options={this.props.options}
          style={{...commonStyles.select, ...this.props.style.select}}
          onChange={(option: Object) => {
            if (option) {
              this.props.onChange(+option.value)
            }
          }}
          onBlur={this.blurHandler}
          className={`select-no-clear-icon select-no-arrow-icon select-interactive ${this.props.stylingClasses}`}
        />
        <div style={commonStyles.controlsWrapper}>
          <div style={{...commonStyles.arrowWrapper, ...this.props.style.arrowWrapper}} onClick={this.increment}>
            <div style={{...commonStyles.arrow, ...commonStyles.up}} />
          </div>
          <div style={commonStyles.arrowWrapper} onClick={this.decrement}>
            <div style={{...commonStyles.arrow, ...commonStyles.bottom}} />
          </div>
        </div>
      </div>
    )
  }
}

export default InteractiveSelect
